import { render } from "./verify-email.vue?vue&type=template&id=3311ff15&scoped=true"
import script from "./verify-email.vue?vue&type=script&lang=js"
export * from "./verify-email.vue?vue&type=script&lang=js"

import "./verify-email.vue?vue&type=style&index=0&id=3311ff15&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3311ff15"]])

export default __exports__